import lottie from 'lottie-web';

export default function initLottie() {
  const lottieElements = document.querySelectorAll('[data-lottie]');

  lottieElements.forEach((el) => {
    const path = el.dataset.lottie;

    const anim = lottie.loadAnimation({
      container: el,
      renderer: 'svg',
      loop: false,
      autoplay: false,
      path: path,
    });
    // Optional: custom speed (1 = normal, 0.75 = slower, 2 = faster)
    anim.setSpeed(0.7);

    // Watch when element enters viewport
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            anim.play();
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.2 }
    );

    observer.observe(el);
  });
}
